// Module
var code = `<!-- clList — bullet or numbered list.
     Data shape (from author):
         { style: "bullet" | "numbered", items: [ "item string (markdown)", ... ] }

     Pipeline normalizations:
         styleIsBullet   — truthy when style === "bullet"
         styleIsNumbered — truthy when style === "numbered"

     Flag-conditional pattern is used because DomElementTemplate cannot switch tag
     names from data. Only the matching branch renders, so the DOM contains exactly
     one <ul> or <ol>, not both. -->
<div class="block-cl-list block-cl-list--{{style}}">
  <ul class="block-cl-list__items">
    {{#items}}<li class="block-cl-list__item">{{.}}</li>{{/items}}
  </ul>

</div>
`;
// Exports
module.exports = code;